import { CalendarEventTypes, type ProgramCalendarEventType } from "@/modules/calendar/calendarTypes"
import { ProgramInfiniteSessionEntity } from "@/modules/sessions/entities/programInfiniteSessionEntity"
import type { ProgramOnOffSessionEntity } from "@/modules/sessions/entities/programOnOffSessionEntity"

export const SessionTypeOf = "SESSION"
export const ProgramInfiniteSessionTypeOf = "CONTINUOUS_PROGRAM_SESSION"
export const ProgramOnOffSessionTypeOf = "ONOFF_PROGRAM_SESSION"

export const convertItemProgramSessionsToEvent = (
  sessions: (ProgramInfiniteSessionEntity | ProgramOnOffSessionEntity)[],
  userId: string,
): ProgramCalendarEventType[] => {
  return sessions.map((session) => {
    const isProgramUser = session.owner.id === userId

    const baseEvent = {
      id: session.id,
      title: session.name,
      editable: isProgramUser,
      blocks: session.blocks,
      cardioTag: session.cardioTag,
      gymnasticTag: session.gymnasticTag,
      weightliftingTag: session.weightliftingTag,
      hideSessionContent: session.hideSessionContent ?? false,
    }

    if (session instanceof ProgramInfiniteSessionEntity) {
      return {
        ...baseEvent,
        date: session.date ?? "",
        virtualProgramByDateIndex: session.virtualProgramByDateIndex ?? undefined,
        _type: CalendarEventTypes.CALENDAR_EVENT,
      }
    } else {
      return {
        ...baseEvent,
        date: session.date ?? "",
        dayIndex: session.index ?? 0,
        restDay: session.restDay,
        _type: CalendarEventTypes.UNDATED_EVENT,
      }
    }
  })
}
